import React, { Component } from 'react';
import './NewBuilding.css';
import { FormControl, Table } from 'react-bootstrap';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import { connect } from 'react-redux';
import { Map } from '../../../shared/map/Map';
import {
  getNewBuildingForm,
  getReadOnly,
  getSelectedBuildingId,
} from '../../../../selectors/admin/work-orders/creation/buildings';
import {
  createBuildingRequest,
  editNewBuilding,
  newBuildingChange,
  removeDocumentRequest,
  updateLocationRequest,
  updateBuildingRequest,
  uploadDocumentsRequest,
} from '../../../../actions/admin/work-orders/creation/buildings';
import Dropzone from 'react-dropzone';
import uploadPng from '../../../../images/upload.png';
import FilesUploadedViewer from '../../../shared/files/FilesUploadedViewer';
import {
  getBuildings,
  getCurrentWorkOrder,
} from '../../../../selectors/admin/work-orders/work-orders';
import {
  getClients,
  getSelectedClientId,
} from '../../../../selectors/admin/work-orders/creation/clients';
import { getCurrentUser } from '../../../../selectors/authentication';
import { ROLES, TYPES, usersUtil } from '../../../../services/utils/users-util';
import { goToClientSelection } from '../../../../actions/admin/work-orders/creation/creation';

/**
 * Shows both steps of a new building. The first "page" shows a form and submitting this creates a new building on the
 * backend. The second "page" allows to select the building from the map, change the form values and upload files.
 */
class NewBuilding extends Component {
  constructor(props) {
    super(props);

    // If user is admin, check if a client is selected, otherwise route to client selection
    if (
      (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
        usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR)) &&
      this.props.selectedClientId === null
    ) {
      this.props.dispatch(goToClientSelection());
    }
  }

  handleChange = (attribute, value) => {
    this.props.dispatch(newBuildingChange(attribute, value));
  };

  handleEditDetails = (event) => {
    event.preventDefault();
    this.props.dispatch(editNewBuilding());
  };

  handleMapMarkerChange = (newPosition) => {
    this.props.dispatch(
      updateLocationRequest(
        this.props.selectedBuildingId,
        newPosition.latitude,
        newPosition.longitude
      )
    );
  };

  handleOnDrop = (files) => {
    this.props.dispatch(
      uploadDocumentsRequest(this.props.selectedBuildingId, files)
    );
  };

  handleDocumentRemove = (documentId) => {
    this.props.dispatch(
      removeDocumentRequest(this.props.selectedBuildingId, documentId)
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.props.selectedBuildingId === 0) {
      // When creating building with Admin user, send selectedClientId to create building
      this.props.dispatch(
        createBuildingRequest(
          this.props.newBuildingForm,
          this.props.selectedClientId !== null
            ? this.props.selectedClientId
            : undefined
        )
      );
    } else {
      const newBuilding = this.props.buildings.find(
        (element) => element.id === this.props.selectedBuildingId
      );
      this.props.dispatch(
        updateBuildingRequest(
          newBuilding.id,
          newBuilding.location.id,
          this.props.newBuildingForm,
          this.props.currentWorkOrder,
          this.props.selectedClientId !== null
            ? this.props.selectedClientId
            : undefined
        )
      );
    }
  };

  render() {
    const newBuilding = this.props.buildings.find(
      (element) => element.id === this.props.selectedBuildingId
    );

    const routeTitle = ['work orders'];
    if (this.props.selectedClientId !== null) {
      const client = this.props.clients.find(
        (client) => client.id === this.props.selectedClientId
      );
      if (client !== undefined) {
        routeTitle.push(client.company_name);
      }
    }
    routeTitle.push('add building');

    return (
      <div className="new-building">
        <RouteTitle titles={routeTitle} />

        <div className="full-title">
          {newBuilding === undefined ? 'Add a Building' : 'Property Details'}
        </div>

        {newBuilding !== undefined && (
          <Map
            latitude={newBuilding.location.latitude}
            longitude={newBuilding.location.longitude}
            onMarkerChanged={this.handleMapMarkerChange}
          />
        )}

        <div className="content-container">
          <div className="building-form-container">
            <div
              className={
                'building-form' + (newBuilding !== undefined ? ' new' : '')
              }
            >
              <div>Building Details</div>

              <form onSubmit={this.handleSubmit}>
                {newBuilding === undefined
                  ? this.getNewFormTable()
                  : this.getEditFormTable()}

                <div className="add-building-btn-container">
                  {newBuilding === undefined ? (
                    <input
                      type="submit"
                      className="btn button button-orange"
                      value="Add Building"
                    />
                  ) : (
                    <React.Fragment>
                      <input
                        type="submit"
                        className="btn button button-gray"
                        value="Edit Details"
                        onClick={this.handleEditDetails}
                      />
                      <input
                        type="submit"
                        className="btn button button-orange"
                        value="Confirm Details"
                      />
                    </React.Fragment>
                  )}
                </div>
              </form>
            </div>

            {newBuilding !== undefined && (
              <div className="building-files">
                <div>
                  Insurance Requirements & Building Rules and Regulations
                </div>
                <div>Please drag and drop any file into this area</div>

                <Dropzone
                  accept="application/pdf, .doc, .docx, .xls, .xlsx"
                  className="building-files-dropzone"
                  onDrop={this.handleOnDrop}
                >
                  <img src={uploadPng} alt="remove" />
                </Dropzone>

                {newBuilding.documents !== undefined && (
                  <FilesUploadedViewer
                    documents={newBuilding.documents}
                    title="Files uploaded:"
                    onDocumentRemove={this.handleDocumentRemove}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  getNewFormTable() {
    return (
      <Table responsive className="new-form-table">
        <colgroup>
          <col width="21%" />
          <col width="21%" />
          <col width="21%" />
          <col width="6%" />
          <col width="6%" />
        </colgroup>
        <tbody>
          <tr>
            <td>{this.getStreetAddressFormControl(false)}</td>
            <td>{this.getFloorFormControl(false)}</td>
            <td>{this.getCityFormControl(false)}</td>
            <td>{this.getStateFormControl(false)}</td>
            <td>{this.getZipCodeFormControl(false)}</td>
          </tr>
          <tr>
            <td>
              <hr />
            </td>
            <td>
              <hr />
            </td>
            <td>
              <hr />
            </td>
            <td>
              <hr />
            </td>
            <td>
              <hr />
            </td>
          </tr>
          <tr>
            <td>{this.getNameFormControl(false)}</td>
            <td />
          </tr>
        </tbody>
      </Table>
    );
  }

  getEditFormTable() {
    return (
      <Table responsive className="edit-form-table">
        <colgroup>
          <col width="50%" />
          <col width="16%" />
          <col width="16%" />
          <col width="18%" />
        </colgroup>
        <tbody>
          <tr>
            <td>{this.getStreetAddressFormControl(this.props.readOnly)}</td>
            <td colSpan={3}>{this.getFloorFormControl(this.props.readOnly)}</td>
          </tr>
          <tr>
            <td>{this.getCityFormControl(this.props.readOnly)}</td>
            <td>{this.getStateFormControl(this.props.readOnly)}</td>
            <td>{this.getZipCodeFormControl(this.props.readOnly)}</td>
          </tr>
          <tr>
            <td>{this.getNameFormControl(this.props.readOnly)}</td>
            <td />
          </tr>
        </tbody>
      </Table>
    );
  }

  getNameFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="Building Name"
        value={this.props.newBuildingForm.name}
        onChange={(event) => this.handleChange('name', event.target.value)}
        readOnly={readOnly}
      />
    );
  }

  getStreetAddressFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="Street Address Name"
        value={this.props.newBuildingForm.streetAddress}
        onChange={(event) =>
          this.handleChange('streetAddress', event.target.value)
        }
        required
        readOnly={readOnly}
      />
    );
  }

  getFloorFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="Unit number / floor"
        value={this.props.newBuildingForm.unitNumber}
        onChange={(event) =>
          this.handleChange('unitNumber', event.target.value)
        }
        readOnly={readOnly}
      />
    );
  }

  getCityFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="City"
        value={this.props.newBuildingForm.city}
        onChange={(event) => this.handleChange('city', event.target.value)}
        required
        readOnly={readOnly}
      />
    );
  }

  getStateFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="State"
        value={this.props.newBuildingForm.state}
        onChange={(event) => this.handleChange('state', event.target.value)}
        required
        readOnly={readOnly}
      />
    );
  }

  getZipCodeFormControl(readOnly) {
    return (
      <FormControl
        type="text"
        className="input"
        placeholder="Zip code"
        value={this.props.newBuildingForm.zipCode}
        onChange={(event) => this.handleChange('zipCode', event.target.value)}
        required
        readOnly={readOnly}
      />
    );
  }
}

export default connect((state) => {
  return {
    buildings: getBuildings(state),
    clients: getClients(state),
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    newBuildingForm: getNewBuildingForm(state),
    readOnly: getReadOnly(state),
    selectedBuildingId: getSelectedBuildingId(state),
    selectedClientId: getSelectedClientId(state),
  };
})(NewBuilding);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/NewBuilding.js